'use strict';

var BaseView = require('./base');

class MatrixFlipColumnView extends BaseView {
    constructor(matrix) {
        super(matrix, matrix.rows, matrix.columns);
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(rowIndex, this.columns - columnIndex - 1, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(rowIndex, this.columns - columnIndex - 1);
    }
}

module.exports = MatrixFlipColumnView;



//////////////////
// WEBPACK FOOTER
// ./~/nmr-simulation/~/ml-matrix/src/views/flipColumn.js
// module id = 120
// module chunks = 0